import React, {
  ReactElement, ReactNode, useMemo, useState,
} from 'react';
import SecurityContext from './SecurityContext';

interface Props {
  children: ReactNode;
}

const SecurityContextProvider = ({ children }: Props): ReactElement => {
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined);
  const [organizationId, setOrganizationId] = useState<string | undefined>(undefined);

  const value = useMemo(
    () => ({
      accessToken, setAccessToken, organizationId, setOrganizationId,
    }),
    [accessToken, organizationId],
  );

  return (
    <SecurityContext.Provider value={value}>
      {children}
    </SecurityContext.Provider>
  );
};

export default SecurityContextProvider;
